<template>
  <c-box>
    <TaskCard
      title="Market Goals"
      :description="'Set your company’s goals'"
      :hasComments="true"
      :hasFooter="true"
      :hasProgress="true"
      :canAssign="true"
      :hasImportance="true"
      :hasNotification="true"
      :hasVisibility="true"
      :hasMounted="hasMounted"
      :disabled="disabled"
      :hasAccess="hasAccess"
      :taskData="foundationData"
      :accessKey="'foundation_assignments'"
      :accessFn="updateAccess"
      :visibilityKey="'foundation_visibilities'"
      :visibilityFn="updateVisibility"
      @update="updateData"
      explanationKey="market_goals"
    >
      <ContentLoader
        v-if="isFetchingData"
        viewBox="0 0 250 130"
        primaryColor="#ddd"
      >
        <rect x="0" y="0" rx="3" ry="3" width="100" height="120" />
        <rect x="120" y="0" rx="3" ry="3" width="100" height="120" />
      </ContentLoader>
      <Traction
        ref="marketGoalCard"
        :isMarketPlan="isMarketPlan"
        :disabled="disabled"
        :type="'market_goal'"
        v-else
      />
    </TaskCard>
  </c-box>
</template>

<script>
import foundationMixin from '@/mixins/foundation.js';
import Traction from './Traction.vue';

import { ContentLoader } from 'vue-content-loader';

import TaskCard from './../TaskCard';
import { getTimelineData } from '@/services/timeline';

import { mapMutations } from 'vuex';

export default {
  components: { Traction, ContentLoader, TaskCard },
  mixins: [foundationMixin],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    isMarketPlan: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      foundationType: 'market_goals',
      hasMounted: false,
    };
  },
  created() {
    this.getTimelineData();
  },
  methods: {
    ...mapMutations({
      setCategories: 'timeline/setCategories',
      setScenarios: 'timeline/setScenarios',
      setPhases: 'timeline/setPhases',
      setMilestones: 'timeline/setMilestones',
    }),
    getTimelineData() {
      getTimelineData(this.activeCompany.id).then((res) => {
        this.setCategories(res.data.calender_category);
        this.setPhases(res.data.phase);
        this.setScenarios(res.data.scenario);
        this.setMilestones(res.data.milestone);
      });
    },
  },
};
</script>

<style></style>
